// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".special-title[data-v-8dc8fa56]{background:#fff;box-shadow:0 2px 4px rgba(0,0,0,.05);border-radius:3px;width:100%;display:flex;justify-content:space-between;align-items:center;padding:15px 24px;box-sizing:border-box;margin-bottom:30px}", ""]);
// Exports
module.exports = exports;
